import React from 'react';
import Immutable from 'immutable';
import { VacancyTeaser } from '../../../../components';

const Teaser = ({ entity, withBackground }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'summary'], '');
  const nid = entity.getIn(['nid', 0, 'value']);
  const path = entity.getIn(['paths', 'nl'], '');
  const department = entity.getIn(['field_department', 0, 'title'], '');
  const location = entity.get('field_address', Immutable.List()).map((term) => term.get('title', '')).join(' of ');
  const employmentType = entity.get('field_employment_type', Immutable.List()).map((term) => term.get('title', '')).join('/');

  return (
    <VacancyTeaser
      nid={nid}
      title={title}
      body={body}
      path={path}
      department={department}
      location={location}
      employmentType={employmentType}
      withBackground={withBackground}
    />
  );
};

export default Teaser;
